module.exports = __webpack_public_path__ + "static/media/smartap.d707dd16.png";